import React, { useEffect, useState } from "react";

const Search = ({
  placeholder = "Search...",
  data,
  onSearch,
  filterBy = "name",
  id,
}) => {
  const [input, setInput] = useState("");

  const handleInput = (e) => {
    e.persist();
    setInput(e.target.value);
  };

  const filterSearch = () => {
    const filtered = data.filter((item) =>
      item[filterBy].toLowerCase().includes(input.toLowerCase())
    );
    onSearch(filtered);
  };

  useEffect(() => {
    clearSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset only when id changes
  }, [id]);

  useEffect(() => {
    filterSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- re-filter only when input changes
  }, [input]);

  const clearSearch = () => {
    setInput("");
    onSearch(data);
  };
  return (
    <div className="flex items-center bg-blue-0 border  w-full pl-2 overflow-hidden rounded-lg h-14">
      <input
        type="text"
        placeholder={placeholder}
        className="flex-1 bg-transparent outline-none text-grey-4 placeholder-grey-3 px-2 border-none search-input"
        onInputCapture={handleInput}
        value={input}
      />
      <button
        className="bg-blue-5 text-white h-14 w-14 flex items-center justify-center"
        onClick={clearSearch}
      >
        <span className="material-symbols-outlined">
          {input ? "close" : "search"}
        </span>
      </button>
    </div>
  );
};

export default Search;
